import React, {createContext, useState, useEffect} from 'react';

export const EntityContext = createContext();

const EntityContextProvider = (props) => {
    const [activeEntity, setActiveEntity] = useState(null);
    const [activeEntitySort, setActiveEntitySort] = useState(0);
    const [updatingEntityCount, setUpdatingEntityCount] = useState(false);
    const [activeEntityStats, setActiveEntityStats] = useState(null);
    const [pendingEntities, setPendingEntities] = useState([]);
    const [entitySocialFilters, setEntitySocialFilters] = useState({
        'twitter': null,
        'facebook': null,
        'youtube': null,
        'rss': null,
        'web': null,
        'google_ozmosys': null,
        'instagram': null
    });
    const [entitySentimentFilters, setEntitySentimentFilters] = useState({
        'neutral': true,
        'negative': true,
        'positive': true,
    });
    const [entitySentimentCount, setEntitySentimentCount] = useState({
        positive: 0,
        neutral: 0,
        negative: 0,
    });
    const [entitySocialCount, setEntitySocialCount] = useState({
        twitter: 0,
        facebook: 0,
        youtube: 0,
        rss: 0,
        web: 0,
        google_ozmosys: 0,
        instagram: 0
    });


    const resetEntityFilters = () => {
        setEntitySocialFilters({
            'twitter': true,
            'facebook': true,
            'youtube': true,
            'rss': true,
            'web': true,
            'google_ozmosys': true,
            'instagram': true
        });
        setEntitySentimentFilters({
            'neutral': true,
            'negative': true,
            'positive': true,
        });
        setEntitySentimentCount({
            positive: 0,
            neutral: 0,
            negative: 0,
        });
        setEntitySocialCount({
            twitter: 0,
            facebook: 0,
            youtube: 0,
            rss: 0,
            web: 0,
            google_ozmosys: 0,
            instagram: 0
        });
    };

    const displayEmptyFilterResults = () => {
        setEntitySentimentCount({
            positive: 0,
            neutral: 0,
            negative: 0,
        });
        setEntitySocialCount({
            twitter: 0,
            facebook: 0,
            youtube: 0,
            rss: 0,
            web: 0,
            google_ozmosys: 0,
            instagram: 0
        });
    }

    return (
        <EntityContext.Provider value={{
            entitySocialFilters,
            setEntitySocialFilters,
            entitySentimentFilters,
            setEntitySentimentFilters,
            activeEntity,
            setActiveEntity,
            activeEntitySort,
            setActiveEntitySort,
            entitySocialCount,
            setEntitySocialCount,
            entitySentimentCount,
            setEntitySentimentCount,
            updatingEntityCount,
            setUpdatingEntityCount,
            activeEntityStats,
            setActiveEntityStats,
            pendingEntities,
            setPendingEntities,
            displayEmptyFilterResults,
            resetEntityFilters,
        }}>
            {props.children}
        </EntityContext.Provider>
    );
};

export default EntityContextProvider;